import { jsx as _jsx } from "react/jsx-runtime";
const DownChevron = (props) => (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 256 256" }, props, { children: _jsx("path", { d: "M225.813 48.907 128 146.72 30.187 48.907 0 79.093l128 128 128-128z" }) })));
export default DownChevron;
//# sourceMappingURL=DownChevron.js.map